import mongoose from "mongoose";

const EXPIRE_TIME = 10 * 24 * 60 * 60;

export interface ProductInfoChunk {
  groupType: string;
  group: string;
  label: string;
  labelFormatCode: string;
  contentDisplayOrder: number;
  containerFormatCode: string;
  displayOrder: number;
  name: string;
  tag: string;
  value: string;
}

export interface ProductInfoImage {
  group: string;
  pixelWidth: string;
  pixelHeight: string;
  orientation: string;
  productColor: string;
  documentTypeDetail: string;
  imageUrlHttp: string;
  imageUrlHttps: string;
}

export interface ProductInfo {
  _id: mongoose.Schema.Types.ObjectId;
  sku: string;
  countryCode: string;
  language: string;
  chunks: ProductInfoChunk[];
  images: ProductInfoImage[];
  createdAt: Date;
}

export const ProductInfoSchema = new mongoose.Schema<ProductInfo>({
  sku: { type: String, index: true },
  countryCode: { type: String, index: true },
  language: { type: String, index: true },
  chunks: [{
    _id: false,
    groupType: String,
    group: String,
    label: String,
    labelFormatCode: String,
    contentDisplayOrder: Number,
    containerFormatCode: String,
    displayOrder: Number,
    name: String,
    tag: String,
    value: String,
  }],
  images: [{
    _id: false,
    group: String,
    pixelWidth: String,
    pixelHeight: String,
    orientation: String,
    productColor: String,
    documentTypeDetail: String,
    imageUrlHttp: String,
    imageUrlHttps: String,
  }],
  createdAt: { type: Date, expires: EXPIRE_TIME, default: Date.now },
});

ProductInfoSchema.index(
  { sku: 1, countryCode: 1, language: 1 },
  { unique: true },
);
